export default __webpack_public_path__ + "static/media/bg1.fac81d99.jpg";